/**
 * @generated SignedSource<<e182b2bd7c8ae9a528d68a01de878e12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SlotLockSubscriptionManagerSubscription$variables = {
  agendaId: string;
};
export type SlotLockSubscriptionManagerSubscription$data = {
  readonly timeSlotsChanged: {
    readonly actor: {
      readonly user: {
        readonly __typename: string;
      } | null | undefined;
    };
    readonly slots: ReadonlyArray<{
      readonly __typename: "TimeSlot";
      readonly id: string;
      readonly lockedUntil: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined>;
  } | null | undefined;
};
export type SlotLockSubscriptionManagerSubscription = {
  response: SlotLockSubscriptionManagerSubscription$data;
  variables: SlotLockSubscriptionManagerSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agendaId"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "agendaIds.0",
        "variableName": "agendaId"
      }
    ],
    "kind": "ListValue",
    "name": "agendaIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedUntil",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SlotLockSubscriptionManagerSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SlotsSubscriptionChange",
        "kind": "LinkedField",
        "name": "timeSlotsChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionActor",
            "kind": "LinkedField",
            "name": "actor",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "slots",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "type": "TimeSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SlotLockSubscriptionManagerSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SlotsSubscriptionChange",
        "kind": "LinkedField",
        "name": "timeSlotsChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionActor",
            "kind": "LinkedField",
            "name": "actor",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "slots",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "TimeSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4a1592f21f206e37d68f97d1800a3812",
    "id": null,
    "metadata": {},
    "name": "SlotLockSubscriptionManagerSubscription",
    "operationKind": "subscription",
    "text": "subscription SlotLockSubscriptionManagerSubscription(\n  $agendaId: ID!\n) {\n  timeSlotsChanged(agendaIds: [$agendaId]) {\n    actor {\n      user {\n        __typename\n        id\n      }\n    }\n    slots {\n      __typename\n      ... on TimeSlot {\n        id\n        lockedUntil\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d5f1f47a838e9c2474a0a08f4b2b4f05";

export default node;
